// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"a8bc8171","405":"9b8e7e33","697":"a1bd873a","766":"b45bcea4","829":"a0e3f476","892":"9b1ffa9c"}[chunkId] + ".chunk.js";
};